<template>
    <div class="row">
        <div class="col">
            <div class="card">
                <div class="card-body">
                    <div class="row">
                        <div class="col-2">
                            <select-input :form="form"
                                          :label="'Edizione'"
                                          name="edition_id"
                                          :options="$editions"
                                          :readonly="readonly"/>
                        </div>
                        <div class="col">
                            <select-input :form="form"
                                          :label="'Sezione'"
                                          name="film_section_id"
                                          :options="$film_sections"
                                          :readonly="readonly"/>
                        </div>
                        <div class="col">
                            <select-input :form="form"
                                          :label="'Stato selezione'"
                                          name="selection_status"
                                          :options="$selection_status"
                                          :readonly="readonly"/>
                        </div>
                    </div>
                </div>
            </div>

            <div class="card">
                <div class="card-body">
                    <div class="row">
                        <div class="col">
                            <text-input :form="form"
                                        :label="'Titolo originale'"
                                        name="original_title"
                                        :readonly="readonly"/>
                        </div>
                        <div class="col">
                            <text-input :form="form"
                                        :label="'Titolo inglese'"
                                        name="english_title"
                                        :readonly="readonly"/>
                        </div>
                        <div class="col">
                            <text-input :form="form"
                                        :label="'Titolo locale'"
                                        name="local_title"
                                        :readonly="readonly"/>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col">
                            <text-input :form="form"
                                        :label="'Registi'"
                                        name="directors"
                                        :readonly="readonly"/>
                        </div>
                        <div class="col">
                            <text-input :form="form"
                                        :label="'Produttori'"
                                        name="producers"
                                        :readonly="readonly"/>
                        </div>
                        <div class="col-2">
                            <text-input :form="form"
                                        :label="'Anno'"
                                        name="year"
                                        :readonly="readonly"/>
                        </div>
                        <div class="col-3">
                            <select-input :form="form"
                                          :label="'Tipo Film'"
                                          name="film_type_id"
                                          :options="$film_types"
                                          :readonly="readonly"/>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col">
                            <multi-select-input :form="form"
                                                :label="'Nazioni'"
                                                name="countries"
                                                :options="$countries"
                                                :readonly="readonly"
                            />
                        </div>
                        <div class="col">
                            <multi-select-input :form="form"
                                                :label="'Lingue'"
                                                name="languages"
                                                :options="$languages"
                                                :readonly="readonly"
                            />
                        </div>
                    </div>

                    <div class="row">
                        <div class="col">
                            <select-input :form="form"
                                          :label="'Colore'"
                                          name="colour"
                                          :options="$colours"
                                          :readonly="readonly"/>
                        </div>
                        <div class="col">
                            <select-input :form="form"
                                          :label="'Durata'"
                                          name="length_type"
                                          :options="$length_types"
                                          :readonly="readonly"/>
                        </div>
                        <div class="col">
                            <text-input :form="form"
                                        :label="'Durata'"
                                        name="runtime"
                                        :readonly="readonly"/>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-12">
                            <div class="card">
                                <div class="card-header">
                                    Selezione
                                </div>
                                <div class="card-body">
                                    <div class="row">
                                        <div class="col">
                                            <text-input :form="form"
                                                        :label="'Mittente'"
                                                        name="submitter"
                                                        :readonly="readonly"/>
                                        </div>
                                        <div class="col">
                                            <text-input :form="form"
                                                        :label="'Email mittente'"
                                                        name="submitter_email"
                                                        :readonly="readonly"/>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="card">
                <div class="card-body">
                    <div class="row">
                        <div class="col">
                            <text-input :form="form"
                                        :label="'Durata effettiva'"
                                        name="runtime_effective"
                                        type="number"
                                        :readonly="readonly"/>
                        </div>
                        <div class="col-2">
                            <checkbox-input :form="form"
                                            :label="'Senza dialoghi'"
                                            name="no_dialogues"
                                            :readonly="readonly"/>
                        </div>
                        <div class="col">
                            <multi-select-input :form="form"
                                                :label="'Sottotitoli copia'"
                                                name="copy_subtitle"
                                                :options="$languages"
                                                :readonly="readonly"
                                                :multiple="false"
                            />
                        </div>
                        <div class="col">
                            <multi-select-input :form="form"
                                                :label="'Sottotitoli proiezione'"
                                                name="projection_subtitle"
                                                :options="$languages"
                                                :readonly="readonly"
                                                :multiple="false"
                            />
                        </div>
                    </div>
                    <div class="row">
                        <div class="col">
                            <text-area-input :form="form"
                                             :label="'Sinossi lunga'"
                                             name="long_synopsis"
                                             :readonly="readonly"/>
                        </div>
                        <div class="col">
                            <text-area-input :form="form"
                                             :label="'Cast'"
                                             name="cast"
                                             :readonly="readonly"/>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import SelectInput from "../components/SelectInput"
import TextAreaInput from "../components/TextAreaInput"
import MultiSelectInput from "../components/MultiSelectInput"
import TextInput from "../components/TextInput"
import {HasError} from "vform/src/components/bootstrap4"
import Multiselect from "vue-multiselect"
import sharedState from "../sharedState"
import CheckboxInput from "../components/CheckboxInput"
import RadioInput from "../components/RadioInput"
import NestedTextInput from "./NestedTextInput"
import companyCards from "../services/api/companyCards"
import peopleCards from "../services/api/peopleCards"
import BusinessCardCompanyMultiSelectInput from "./BusinessCardCompanyMultiSelectInput"

export default {
    components: {
        BusinessCardCompanyMultiSelectInput,
        NestedTextInput,
        SelectInput,
        TextAreaInput,
        MultiSelectInput,
        TextInput,
        HasError,
        Multiselect,
        CheckboxInput,
        RadioInput
    },
    name: "FilmCardForm",
    props: {
        form: Object,
        readonly: {type: Boolean, default: false},
        type: {type: String, default: 'show'},
    },
    data() {
        return {
            sharedState: sharedState,
        }
    },
    methods: {
        async asyncCompaniesFind(queryString) {
            return await companyCards.index(queryString)
        },
        async asyncFilmFind(queryString) {
            return await peopleCards.index(queryString)
        }
    }
}
</script>

<style scoped>

</style>
